module.exports = __webpack_public_path__ + "static/img/sweter_r.d756a11d.webp";